export type getErrorMessageParams = {
  validationMessage?: string;
  questionErrorMessage?: string;
  fallbackMessage?: string;
};

export const getErrorMessage = ({
  validationMessage,
  questionErrorMessage,
  fallbackMessage,
}: getErrorMessageParams): string | undefined => {
  return validationMessage || questionErrorMessage || fallbackMessage;
};
